import { createReducer, on } from '@ngrx/store';
import * as EdgeEditActions from '@states/edge-edit/edge-edit.actions';
import { Edge } from '../../../edge/edge.model';
import { HeartbeatEntry } from '../../../development/heartbeat.service';
import { ThumbnailEntity } from '../../../cameras/camera-thumbnails/camera-thumbnails.model';
import { LiveKitModels } from '@models/livekit.model';
import { PlaybackMonitoringModels } from '@models/playback-monitoring.models';
export declare interface EdgeEditState {
  // will need these when routing will be fixed.
  selectedLocationId: string;
  selectedEdgeId: string;
  selectedEdge: Edge.EdgeDocument; //consist Location Id and edge Id,
  logs: string[];
  heartbeats: HeartbeatEntry[];
  systemStatus: [];
  systemStatusDateFrom: number;
  systemStatusDateTo: number;
  systemStatuPaginationTimeStamps: number;
  heartBeatsDateFrom: number;
  heartBeatsDateTo: number;
  thumbnailsBitmap: ThumbnailEntity[];
  heartBeatsPaginationTimeStamps: number;
  hasChanged: boolean;
  edgeRecoveryDocument: any;
  edgeHeartBeatStatus: any[];
  edgeIPInfos: any[];
  isSaving: boolean;
  hideRefreshInSwUpdateTab: boolean;
  pingLoader: boolean;
  digLoader: boolean;
  traceLoader: boolean;
  firewallLoader: boolean;
  speedTestLoader: boolean;
  testCamerasConnectionLoader: boolean;
  installationLoader: boolean;
  testConnectionLoader: boolean;
  isRebooting: boolean;
  streamingServiceRegion: LiveKitModels.LiveKitServerRegion;
  streamingServiceRegionLoader: boolean;
  latencyResult: LiveKitModels.ServerLatency;
  playbacks: PlaybackMonitoringModels.PlaybackListItem[];
  activePlayback: PlaybackMonitoringModels.PlaybackListItem;
}

export const initialState: EdgeEditState = {
  selectedLocationId: null,
  selectedEdgeId: null,
  selectedEdge: null,
  logs: null,
  heartbeats: null,
  systemStatus: null,
  systemStatusDateFrom: null,
  systemStatusDateTo: null,
  systemStatuPaginationTimeStamps: null,
  heartBeatsDateFrom: null,
  heartBeatsDateTo: null,
  thumbnailsBitmap: null,
  heartBeatsPaginationTimeStamps: null,
  hasChanged: false,
  edgeRecoveryDocument: null,
  edgeHeartBeatStatus: null,
  edgeIPInfos: null,
  isSaving: false,
  hideRefreshInSwUpdateTab: false,
  pingLoader: false,
  digLoader: false,
  traceLoader: false,
  firewallLoader: false,
  speedTestLoader: false,
  testCamerasConnectionLoader: false,
  installationLoader: false,
  testConnectionLoader: false,
  isRebooting: false,
  streamingServiceRegion: null,
  streamingServiceRegionLoader: false,
  latencyResult: null,
  playbacks: [],
  activePlayback: null,
};

export const edgeEditStateReducer = createReducer(
  initialState,
  on(EdgeEditActions.resetToInitialState, state => {
    return {
      ...initialState,
    };
  }),
  on(EdgeEditActions.setSelectedLocationId, (state, { selectedLocationId }) => {
    return {
      ...state,
      selectedLocationId,
    };
  }),
  on(EdgeEditActions.setSelectedEdgeId, (state, { selectedEdgeId }) => {
    return {
      ...state,
      selectedEdgeId,
    };
  }),
  on(EdgeEditActions.setSelectedEdge, (state, { selectedEdge }) => {
    return {
      ...state,
      selectedEdge,
    };
  }),
  on(EdgeEditActions.setEdgeAWSLogs, (state, { logs }) => {
    return {
      ...state,
      logs,
    };
  }),
  on(EdgeEditActions.getHeartbeatsSuccess, (state, { heartbeats }) => {
    return {
      ...state,
      heartbeats: state.heartbeats ? state.heartbeats.concat(heartbeats) : [].concat(heartbeats),
    };
  }),
  on(EdgeEditActions.getCameraThumbnailsSuccess, (state, { thumbnailsBitmap }) => {
    return {
      ...state,
      thumbnailsBitmap,
    };
  }),
  on(EdgeEditActions.setHeartbeatsDateRAnge, (state, { from, to }) => {
    return {
      ...state,
      heartBeatsDateFrom: from,
      heartBeatsDateTo: to,
      heartBeatsPaginationTimeStamps: initialState.heartBeatsPaginationTimeStamps,
      heartbeats: initialState.heartbeats,
    };
  }),
  on(EdgeEditActions.setEdgeSystemStatusPagination, state => {
    return {
      ...state,
      //@ts-ignore
      systemStatuPaginationTimeStamps: parseInt(state.systemStatus[state.systemStatus.length - 1].timestamp),
    };
  }),
  on(EdgeEditActions.setHasChanged, (state, { hasChanged }) => {
    return {
      ...state,
      hasChanged,
    };
  }),
  on(EdgeEditActions.getCoreRecoveryDocumentSuccess, (state, { edgeRecoveryDocument }) => {
    return {
      ...state,
      edgeRecoveryDocument,
    };
  }),
  on(EdgeEditActions.getEdgeHeartBeatStatusSuccess, (state, { body }) => {
    return {
      ...state,
      edgeHeartBeatStatus: body,
    };
  }),
  on(EdgeEditActions.getEdgeIPInfosSuccess, (state, { data }) => {
    return {
      ...state,
      edgeIPInfos: data,
    };
  }),
  on(EdgeEditActions.setIsSaving, (state, { isSaving }) => {
    return {
      ...state,
      isSaving,
    };
  }),
  on(EdgeEditActions.setHideRefreshInSwUpdateTab, (state, { hidden }) => {
    return {
      ...state,
      hideRefreshInSwUpdateTab: hidden,
    };
  }),
  on(EdgeEditActions.ping, (state) => {
    return {
      ...state,
      pingLoader: true,
    };
  }),
  on(EdgeEditActions.setPingLoader, (state, { pingLoader }) => {
    return {
      ...state,
      pingLoader: pingLoader,
    };
  }),
  on(EdgeEditActions.dig, (state) => {
    return {
      ...state,
      digLoader: true,
    };
  }),
  on(EdgeEditActions.setDigLoader, (state, { digLoader }) => {
    return {
      ...state,
      digLoader,
    };
  }),
  on(EdgeEditActions.traceroute, (state) => {
    return {
      ...state,
      traceLoader: true,
    };
  }),
  on(EdgeEditActions.setTracerLoader, (state, { traceLoader }) => {
    return {
      ...state,
      traceLoader,
    };
  }),
  on(EdgeEditActions.firewallTest, (state) => {
    return {
      ...state,
      firewallLoader: true,
    };
  }),
  on(EdgeEditActions.setFirewallLoader, (state, { firewallLoader }) => {
    return {
      ...state,
      firewallLoader,
    };
  }),
  on(EdgeEditActions.speedTest, (state) => {
    return {
      ...state,
      speedTestLoader: true,
    };
  }),
  on(EdgeEditActions.setSpeedTestLoader, (state, { speedTestLoader }) => {
    return {
      ...state,
      speedTestLoader,
    };
  }),
  on(EdgeEditActions.testCamerasConnection, (state) => {
    return {
      ...state,
      testCamerasConnectionLoader: true,
    };
  }),
  on(EdgeEditActions.setTestAllCamerasConnectionLoader, (state, { testCamerasConnectionLoader }) => {
    return {
      ...state,
      testCamerasConnectionLoader,
    };
  }),
  on(EdgeEditActions.checkEdgeInstallation, (state) => {
    return {
      ...state,
      installationLoader: true,
    };
  }),
  on(EdgeEditActions.setInstallationLoader, (state, { installationLoader }) => {
    return {
      ...state,
      installationLoader,
    };
  }),
  on(EdgeEditActions.testConnection, (state) => {
    return {
      ...state,
      testConnectionLoader: true,
    };
  }),
  on(EdgeEditActions.setTestConnectionLoader, (state, { testConnectionLoader }) => {
    return {
      ...state,
      testConnectionLoader,
    };
  }),
  on(EdgeEditActions.setIsRebooting, (state, { isRebooting }) => {
    return {
      ...state,
      isRebooting,
    };
  }),
  on(EdgeEditActions.getLiveKitRegion, (state) => {
    return {
      ...state,
      streamingServiceRegion: initialState.streamingServiceRegion,
      latencyResult: initialState.latencyResult,
      streamingServiceRegionLoader: true,
    };
  }),
  on(EdgeEditActions.getLiveKitRegionSuccess, (state, { region }) => {
    return {
      ...state,
      streamingServiceRegion: region,
      streamingServiceRegionLoader: false,
    };
  }),
  on(EdgeEditActions.getLiveKitRegionFail, (state) => {
    return {
      ...state,
      streamingServiceRegionLoader: false,
    };
  }),
  on(EdgeEditActions.forceLiveKitRegionSuccess, (state, { region }) => {
    return {
      ...state,
      streamingServiceRegion: region,
    };
  }),
  on(EdgeEditActions.getLiveKitLatencySuccess, (state, { result }) => {
    return {
      ...state,
      latencyResult: result,
    };
  }),
  on(EdgeEditActions.getPlaybackMonitoringSuccess, (state, { playbacks }) => {
    return {
      ...state,
      playbacks,
    };
  }),
  on(EdgeEditActions.setActivePlayback, (state, { activePlayback }) => {
    return {
      ...state,
      activePlayback,
    };
  }),
);
